import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CropRotateIcon(props: IconProps) {
    return <Icon {...props} iconKey={"crop_rotate"}/>
}
